import {Component, Inject, OnInit, ViewChildren, ElementRef, QueryList, DOCUMENT} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {Paintings} from '../shared/Paintings';

import {ConfigService} from '../config/config.service';
import { TranslateService } from '@ngx-translate/core';
import {LanguageService} from '../service/language.service';
import {Meta, Title} from '@angular/platform-browser';

@Component({
    selector: 'app-gallery',
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss'],
    standalone: false
})
export class GalleryComponent implements OnInit {
  @ViewChildren('lazyElement', { read: ElementRef }) lazyElements!: QueryList<ElementRef>;

  // tslint:disable-next-line:variable-name max-line-length
  constructor(@Inject(DOCUMENT) private document: Document,
              public dialog: MatDialog, public router: Router, private api: ConfigService,
              // tslint:disable-next-line:variable-name
              private translate: TranslateService, private _language: LanguageService, private meta: Meta, private meta_title: Title) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }

  isLoaderVisible = false;
  paintings: Paintings[] = [];
  chosenCategory = 1;
  isJustAvailableVisible = false;
  tabIndex = 0;
  isDataReady = false;

  getPaintings(): void {
    this.isDataReady = false;
    this.isLoaderVisible = true;
    this.api.GetPaintings(String(this.chosenCategory)).subscribe(
      data => {
        // @ts-ignore
        this.paintings = data;
        setTimeout(() => {
          this.initializeIntersectionObserver();
          this.isLoaderVisible = false;
          this.isDataReady = true;
        }, 0);
      },
      error => {
        console.log('oops', error);
        this.isLoaderVisible = false;
        this.isDataReady = true;
      }
    );
  }
  // tslint:disable-next-line:typedef
  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  filterPaintingsByAvailability(): void {
    const allPaintings = this.paintings;
    if (this.isJustAvailableVisible) {
      this.isLoaderVisible = true;
      const availablePaintings = allPaintings.filter(paintings => paintings.availability === 0);
      this.delay(1000).then( () => {
        this.isLoaderVisible = false;
      });
      this.paintings = availablePaintings;
    } else {
      this.getPaintings();
    }

  }
  toggleAvailable(): void {
    this.isJustAvailableVisible = !this.isJustAvailableVisible;
    this.filterPaintingsByAvailability();
  }
  changeCategory($event: any): void {
    this.paintings = [];
    this.isJustAvailableVisible = false;
    const newCategory = $event.index;
    let backendCategory = 0;
    switch (newCategory){
      case 0: {
        backendCategory = 1; // canvas
        break;
      }
      case 1: {
        backendCategory = 2; // wall
        break;
      }
      case 2: {
        backendCategory = 4; // special gift
        break;
      }
      case 3: {
        backendCategory = 3; // martisoare
        break;
      }
      case 4: {
        backendCategory = 5; // craciun
        break;
      }
    }
    this.chosenCategory = backendCategory;
    this.getPaintings();
  }
  getTabCategory(): void {
    switch (this.chosenCategory){
      case 1: { // 1 - 0
        this.tabIndex = 0; // canvas
        break;
      }
      case 2: { // 2 - 1
        this.tabIndex = 1; // wall
        break;
      }
      case 4: { // 4 - 2
        this.tabIndex = 2; // special gift
        break;
      }
      case 3: { // 3- 3
        this.tabIndex = 3; // martisoare
        break;
      }
      case 5: { // 5 - 4
        this.tabIndex = 4; // craciun
        break;
      }
    }
  }
  getCategoryId(): void {
    const constCategoryId = localStorage.getItem('homeCategoryId');
    if (constCategoryId) {
      this.chosenCategory = Number(constCategoryId);
      this.getTabCategory();
    }
  }
  initializeIntersectionObserver(): void {
    // tslint:disable-next-line:no-shadowed-variable
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    this.lazyElements.forEach(element => observer.observe(element.nativeElement));
  }


  async ngOnInit(): Promise<void> {
    this.meta_title.setTitle('Lupul Creativ - Galerie de Artă');
    this.meta.updateTag({ name: 'description', content: 'Vizitează galeria noastră și descoperă lucrări de artă unice formate din picturi pe pânză, picturi pe perete, cadouri speciale, ornamente de Crăciun și mărțișoare' });
    this.meta.updateTag({ name: 'keywords', content: 'galerie de artă, picturi, artă originală, lucrări personalizate, picturi pânză, picturi pe perete, picturi murale, mărțișoare, ornamente Crăciun' });
    await this.getCategoryId();
    await this.getPaintings();
    localStorage.removeItem('homeCategoryId');
  }
}
